import { BpContext, AppContext } from "./context/AppContext";
import Header from "./shared/Header";
import Onboarding from "./onboarding/Onboarding";
import LoadingOverlay from "react-loading-overlay-ts";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { confirm } from "react-confirm-box";
import "./App.css";
import "./Print.css";
import PatientRegistration from "./hospital/patient/PatientRegistration";
import LocalDataService from "./services/localdata.service";
import PatientDetail from "./hospital/patient/PatientDetail";
import { library } from "@fortawesome/fontawesome-svg-core";
// import { fab } from '@fortawesome/free-brands-svg-icons'
import {
  faMagnifyingGlass,
  faPlus,
  faCalendarPlus,
  faTrash,
  faPrint,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import ImportService from "./hospital/ImportService";
import Pos from "./hospital/Pos";
import Erx from "./hospital/Erx/Erx";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Lob from "./masters/Lob";
import PointOfServiceDelivery from "./masters/PointOfServiceDelivery";
import Specialization from "./masters/Specialization";
import UserType from "./masters/UserType";
import ProtectedRoute from "./shared/auth/ProtectedRoute";
import Login from "./shared/auth/Login";
import tokenService from "./services/token.service";
import AuthService from "./services/auth.service";
import Logout from "./shared/auth/Logout";
import Businesses from "./shared/Businesses";
import Dashboard from "./shared/Dashboard";
import InvoiceComponent from "./billing/InvoiceComponent";
import PyamentCollection from "./billing/PaymentCollection";
import NewStaff from "./staff/NewStaff";
import StaffDetail from "./staff/StaffDetail";
import Opd from "./hospital/Opd";
library.add(
  faMagnifyingGlass,
  faPlus,
  faCalendarPlus,
  faTrash,
  faPrint,
  faArrowUpRightFromSquare
);

function App() {
  const [isLoaderActive, setLoaderActive] = useState(false);

  const [bp, setBp] = useState({
    loggedIn: false,

    kapid_id: "",
    sys_id: 0,
    user_type_id: 0,
    user_type_name: "",
    user_name: "",
    contact_type_id: 0,
    contact_type: "",
    contact_value: "",
    bp: [],
    selectedBp: 0,
    bpId: "bp1",
    bpName: "Swastika Nursing Home",
    bpBrId: "bpbr1",
    bpBrName: "Agarpara Branch",
    address: "P-30, Purbayan, Belgharia, Kol-56",
  });
  const fetchLoggedInUser = async () => {
    const user = tokenService.getUser();
    if (!user) {
      setBp({ loggedIn: false });
    } else {
      const response = await AuthService.getCurrentUser();
      if (response !== false && response.kapid_id) {
        if (response.bp.length === 0) {
          setBp({ loggedIn: true, selectedBp: 0, ...response });
        } else if (response.bp.length === 1) {
          LocalDataService.setDefaultBp(
            response.kapid_id,
            response.bp[0].bp_kapid_id,
            response.bp[0].branches[0]
          );
          setBp({
            loggedIn: true,
            selectedBp: response.bp[0].bp_kapid_id,
            bpBrId: response.bp[0].branches[0],
            ...response,
          });
        } else {
          let defaultbp = LocalDataService.getDefaultBp(response.kapid_id);
          if (defaultbp.bp_id === 0) {
            setBp({ loggedIn: true, selectedBp: 0, ...response });
          } else {
            let selectedBp = response.bp.find(
              (x) => x.bp_kapid_id === defaultbp.bp_id
            );
            setBp({
              loggedIn: true,
              selectedBp: selectedBp ? selectedBp.bp_kapid_id : 0,
              bpBrId: selectedBp ? selectedBp.branches[0] : 0,
              ...response,
            });
          }
        }
        // setBp({ loggedIn: true, ...response });
      }
    }
  };
  useEffect(() => {
    fetchLoggedInUser();
  }, []);

  const options = {
    render: (message, onConfirm, onCancel) => {
      return (
        <>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Confirmation</h5>
            </div>
            <div className="card-body">
              <p
                className="card-text"
                dangerouslySetInnerHTML={{ __html: message }}
              ></p>
            </div>
            <div className="card-footer d-flex justify-content-end">
              <Button variant="danger" onClick={onConfirm} className="me-2">
                Yes
              </Button>
              <Button variant="secondary" onClick={onCancel} className="me-2">
                No
              </Button>
            </div>
          </div>
        </>
      );
    },
  };
  const myConfirm = async (message, toastAlert = "Action aborted!!!") => {
    const result = await confirm(message, options);
    if (result) return true;
    else {
      if (toastAlert !== false) {
        toast.info(toastAlert);
      }
      return false;
    }
  };

  // if (!bp.selectedBp) return "select a bp";

  return (
    <>
      <Router>
        <AppContext.Provider value={[setLoaderActive, toast, myConfirm]}>
          <BpContext.Provider value={bp}>
            <Header />
            <LoadingOverlay
              active={isLoaderActive}
              spinner
              text="Loading your content..."
            >
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    bp.selectedBp ? (
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    ) : (
                      <ProtectedRoute>
                        <Businesses setBp={setBp} />
                      </ProtectedRoute>
                    )
                  }
                ></Route>
                <Route
                  exact
                  path="/businesses"
                  element={
                    <ProtectedRoute>
                      <Businesses setBp={setBp} />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route exact path="/onboard" element={<Onboarding />}></Route>
                <Route
                  exact
                  path="/patient"
                  element={
                    <ProtectedRoute>
                      <PatientRegistration />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  exact
                  path="/patient/:patientId"
                  element={
                    <ProtectedRoute>
                      <PatientDetail />
                    </ProtectedRoute>
                  }
                ></Route>

                <Route
                  exact
                  path="/staff/new"
                  element={
                    <ProtectedRoute>
                      <NewStaff />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  exact
                  path="/staff/:kapid_id"
                  element={
                    <ProtectedRoute>
                      <StaffDetail />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  exact
                  path="/patient/:patientId/invoice/:invoiceId"
                  element={
                    <ProtectedRoute>
                      <InvoiceComponent />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  exact
                  path="/patient/:patientId/collect/:invoiceId"
                  element={
                    <ProtectedRoute>
                      <PyamentCollection />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  exact
                  path="/services"
                  element={<ImportService />}
                ></Route>
                <Route exact path="/pos" element={<Pos />}></Route>
                <Route exact path="/booking" element={<Opd />}></Route>
                <Route
                  exact
                  path="/erx/:patientId/:doctorId"
                  element={<Erx />}
                ></Route>
                <Route exact path="/masters/lob" element={<Lob />}></Route>
                <Route
                  exact
                  path="/masters/posd"
                  element={<PointOfServiceDelivery />}
                ></Route>
                <Route
                  exact
                  path="/masters/specialization"
                  element={<Specialization />}
                ></Route>
                <Route
                  exact
                  path="/masters/usertypes"
                  element={<UserType />}
                ></Route>
                <Route exact path="/auth/login" element={<Login />}></Route>
                <Route exact path="/auth/logout" element={<Logout />}></Route>
              </Routes>
              {/* {activeMenu === "erx" && (
              <Erx ></Erx>
            )} */}
            </LoadingOverlay>
            <ToastContainer />
          </BpContext.Provider>
        </AppContext.Provider>
      </Router>
    </>
  );
}

export default App;
